module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/quick-links/quick-links.component.css
// module id = ./src/app/quick-links/quick-links.component.css
// module chunks = main